import React, { useCallback } from 'react';

import { IRelation, useRelations } from '../../../hooks/Relations';
import { useConfiguration } from '../../../hooks/Configuration';
import { EMessageDirection, EMessageType, IOutcommingNode, useMessages } from '../../../hooks/Messages';

export interface IFaqProps extends IRelation {
}

function Faq({ id, textLong, textShort }: IFaqProps) {
    const configuration = useConfiguration();
    const { setId } = useRelations();
    const { push } = useMessages();

    const clickHandler = useCallback(
        () => {
            setId(0);
            push({
                direction: EMessageDirection.Outcomming,
                type: EMessageType.Node,
                payload: {
                    nodeId: id,
                    text: textLong || textShort
                } as IOutcommingNode
            });
        },
        [setId, push, id, textLong, textShort]
    );

    return (
        <button
            className='stx-chat-faq'
            style={{
                backgroundColor: configuration?.styles.faqBgColor,
                color: configuration?.styles.faqTextColor
            }}
            onClick={clickHandler}>
            {textShort}
        </button>
    );
}

export default Faq;
